// extracted by mini-css-extract-plugin
export default {"textAreaBox":"TextArea_textAreaBox__d76gc"};